'use strict';


import { Vector2 } from 'three';
import vertex from './vertex.glsl';
import fragment from './fragment.glsl'

export const DownsampleShader = {
	name: 'DownsampleShader',
	defines: {},
	uniforms: {
		tDiffuse: {
			value: null
		},
		texelSize: {
			value: new Vector2()
		}
	},
	vertexShader: vertex,
	fragmentShader: fragment
};
